define(function RiqListenerRouteChangeStateMutationModule() {
  'use strict';

  var mutations = function mutations() {
    var Mutations = {
      /**
       * Init state
       * @function init
       * @return {Object} - new state
       **/
      init: function init() {
        var state = {
          previousState: {},
          browseType: '',
          startMode: 'manual'
        };
        return state;
      },
      setPreviousState: function setPreviousState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          previousState: _payload
        });
      },
      setNextState: function setNextState(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          nextState: _payload
        });
      },
      resetBookTracking: function resetBookTracking(_moduleState) {
        return Object.assign({}, _moduleState, {
          browseType: '',
          startMode: 'manual'
        });
      },
      setBrowseType: function setBrowseType(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          browseType: _payload
        });
      },
      setStartMode: function setStartMode(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {
          startMode: _payload
        });
      }
    };

    return Mutations;
  };

  return mutations;
});
